// Vuex auth module
import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        authenticated: false
    },
    mutations: {
        init (state) {
            state.authenticated = !!localStorage.getItem('auth_token'); // BUG: returns true with 'undefined'
            state.roles = localStorage.getItem('auth_roles');

            if (!state.roles) {
                state.roles = [];
            }

            if (state.authenticated) {
                Vue.axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('auth_token');
            }
        },
        login (state, responseData) {
            state.authenticated = true;
            state.roles = responseData.roles;

            localStorage.setItem('auth_token', responseData.token);
            localStorage.setItem('auth_roles', responseData.roles);
            Vue.axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('auth_token');
        },
        logout (state) {
            state.authenticated = false;
            state.roles = [];

            localStorage.removeItem('auth_token');
            Vue.axios.defaults.headers.common.Authorization = '';
        }
    },
    actions: {
        init (context) {
            context.commit('init');
        },
        login (context, responseData) {
            context.commit('login', responseData);
        },
        logout (context) {
            context.commit('logout');
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js